var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box"},[_c('a-card',_vm._b({},'a-card',_vm.$attrs,false),[_c('template',{slot:"extra"},[_vm._t("head")],2),_vm._t("body")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }